import React, { useState, useEffect, FC }from 'react';
import { Col, Container, Row } from 'reactstrap';
import { IFollowup } from "@interfaces/screens/followup.interface";
import FollowupPresenter from "../../../presenters/screens/followup.presenter";
import TreeView from 'devextreme-react/tree-view';
import SubProject from './subprojects';
import SubProjectByProject from './by-project'; 
import SubProjectByCountry from './by-country';

import styles from './followup.module.scss';

const IndexFollowup: FC<any> = () => {
	const [dataColumns, setDataColumns] = useState(null);
	const [currentView, setCurrentView] = useState(0);
    const [nav, setNav] = useState([]);

    const view: IFollowup = {
        state: {
            dataColumns: dataColumns,
            setDataColumns: setDataColumns,
        },
    };

	const presenter = new FollowupPresenter(view);

    useEffect(() => {
        if(presenter.followupLabels){
            setNav([
                {
                    id:"1",
                    text: presenter.followupLabels.get('indexSubProjects'),
                    expanded:false,
                    items:[],
                },
                {
                    id:"2",
                    text: presenter.followupLabels.get('overlap'),
                    expanded:true,
                    items:[
                        {
                            id:"2_1",
                            text: presenter.followupLabels.get('subProjectsByProject')
                        },
                        {
                            id:"2_2",
                            text: presenter.followupLabels.get('projectsByCountry')
                        }
                    ]
                }
            ])
        }
    }, [presenter.followupLabels]);
    
    useEffect(() => {
        presenter.initialize();
    }, []);

    useEffect(() => {
        if(nav?.length && dataColumns && presenter.formMasters, presenter.followupData) presenter.unSetLoading();
    }, [nav, dataColumns]);

    const getIndexDataGrid = (e:any) => {
        const element = e.element.querySelectorAll(".dx-treeview-item");
        element.forEach((item:HTMLElement) => {
            item.classList.remove(styles.selectedItem);
        });        
        switch(e.itemData.id){
            case "2":
                setCurrentView(1);
                break;
            case "2_1":
                setCurrentView(1);
                break;
            case "2_2":
                setCurrentView(2);
                break;
            default:
                setCurrentView(0);
                break;
        }
        e.itemElement.classList.add(styles.selectedItem);
    }

    const getCurrentView = () => {
        switch(currentView){
            case 0: return <SubProject dataColumns={dataColumns} /> ;                
            case 1: return <SubProjectByProject dataColumns={dataColumns} />;                
            case 2: return <SubProjectByCountry dataColumns={dataColumns}/>;                
        }
    }

  const render = () => {
    return (
      <Container fluid>
            <Row>
                <Col xs="4" sm="4" md="3" lg="2" xl="2">
                {nav.length &&
                    <TreeView
                        dataSource={nav}
                        selectionMode="single"
                        selectByClick={true}
                        onItemSelectionChanged={getIndexDataGrid}
                        focusStateEnabled={false}
                        activeStateEnabled={true}
                    />
                }
                </Col>
                <Col xs="8" sm="8" md="9" lg="10" xl="10">
                    {getCurrentView()}
                </Col>
            </Row>
        </Container>
    )
  }

  if(!presenter.followupData || !dataColumns) return <></>
  return render();
};

export default IndexFollowup;
